var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8568_100581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7.133L5.90337 10.4172L6.17811 10.1185V7.15911L8.72232 5.76816V12.1395L5.95621 13.7654L0 10.2635V7.133Z",
    fill: "url(#paint0_linear_8568_100581)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70653 1.76463L2.82105 5.18295L2.92926 5.57621L5.73095 7.17621V9.78674L0 6.63137V3.6419L5.95621 0.157898L8.70653 1.76463Z",
    fill: "url(#paint1_linear_8568_100581)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13085 11.8991L9.15338 5.2825L8.83191 5.1844L5.96664 6.76524L3.3877 5.33661L9.11717 2.00461L11.8991 3.6305V10.2711L9.13085 11.8991Z",
    fill: "url(#paint2_linear_8568_100581)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.95621 13.7648L5.90337 10.4175L0 7.13327V10.2638L5.95621 13.7648Z",
    fill: "url(#paint3_linear_8568_100581)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15339 5.28249L11.8989 3.63049V10.2711L9.13086 11.8991L9.15339 5.28249Z",
    fill: "url(#paint4_linear_8568_100581)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82105 5.18295L0 3.64274L5.95621 0.157898L8.70653 1.76463L2.82105 5.18295Z",
    fill: "url(#paint5_linear_8568_100581)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8568_100581",
    x1: 0,
    y1: 9.76679,
    x2: 8.72232,
    y2: 9.76679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34259D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3425A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#3428B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3429BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#342AC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8568_100581",
    x1: -85.4023,
    y1: 31.7886,
    x2: -76.7132,
    y2: 31.7886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34259D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3425A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#3428B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3429BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#342AC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8568_100581",
    x1: -27.415,
    y1: 84.6239,
    x2: -18.7674,
    y2: 84.6239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34259D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3425A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#3428B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3429BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#342AC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8568_100581",
    x1: 0,
    y1: 10.4491,
    x2: 5.95621,
    y2: 10.4491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3470C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3442C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8568_100581",
    x1: 9.13086,
    y1: 7.76481,
    x2: 11.8989,
    y2: 7.76481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3470C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3442C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8568_100581",
    x1: 0,
    y1: 2.67042,
    x2: 8.70653,
    y2: 2.67042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3470C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3442C1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8568_100581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 13.6842,
    fill: "white",
    transform: "translate(0 0.157898)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsv);
export default __webpack_public_path__ + "static/media/Bsv.97fb2c9d78bc750115a3e06de588c3d1.svg";
export { ForwardRef as ReactComponent };